<div class="button-wrapper">
  <div class="last-group">
    <div class="last-group-permission-wrapper" *checkPermission="permissionEdit">
      @if (!edit) {
        <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <button class="extra-button yellow" (click)="editForm($event)">
            <img src="assets/ico/edit.svg" alt="edit" />
          </button>
        </div>
      }
      @if (!edit && !hideClone) {
        <div ngbTooltip="{{'buttons.clone' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <button class="extra-button orange" (click)="cloneForm()">
            <img src="assets/ico/copy-regular.svg" alt="clone" />
          </button>
        </div>
      }
      @if (!edit && subsection !== 'budget') {
        <span ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <app-modal-info title="Confirm action" [text]="deleteText" color="red" isQuestion="false"
            iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="delete()">
            <span action>
              <button class="extra-button red" [class.disabled]="disableDelete">
                <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
              </button>
            </span>
          </app-modal-info>
        </span>
      }

      @if (!edit && subsection === 'budget') {
        <div ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <button class="extra-button red" [class.disabled]="disableDelete" (click)="budgetDeletion()">
            <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
          </button>
        </div>
      }

      @if (subsection == 'budget' && form.value.identifier && !edit) {
        <span
          ngbTooltip="{{'buttons.fillBudget' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <button class="extra-button light-blue" (click)="budgetFill()">
            <img class="save" src="assets/ico/fill.svg" alt="projectManagement" />
          </button>
        </span>
      }

      @if (subsection == 'budget' && form.value.identifier && !edit) {
        <div
          ngbTooltip="{{'buttons.projectManagement' | translate}}" tooltipClass="animation-tooltip" placement="top"
          container="body" triggers="hover">
          <button class="extra-button light-blue" (click)="newProject()">
            <img class="save" src="assets/ico/jira-brands.svg" alt="projectManagement" />
          </button>
        </div>
      }
    </div>
    @if (edit) {
      <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top"
        container="body" triggers="hover">
        <button class="extra-button green" [disabled]="form.invalid"
          (click)="saveForm()">
          <img class="save" src="assets/ico/save.svg" alt="save" />
        </button>
      </div>
    }
    @if (edit) {
      <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top"
        container="body" triggers="hover">
        <button class="extra-button red" (click)="cancelForm()">
          <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
        </button>
      </div>
    }
    @if (edit && subsection == 'workinghours') {
      <div>
        <button class="extra-button fulltime" (click)="fillFullTime()">
          <div class="button-icon icon fill-white" aria-label="clock" [inlineSVG]="'assets/ico/clock.svg'"></div>
          <div class="text">Full time</div>
        </button>
      </div>
    }




  </div>
</div>